<template>
  <div class="c-topCsvKeiyaku" v-if="previews.length !== 0">
    <div class="c-topCsvKeiyaku__title">契約住戸について</div>
    <ul class="c-topCsvKeiyaku__cards">
      <li
        class="c-topCsvKeiyaku__cards__card"
        v-for="(preview, i) in previews"
        :key="'c-topCsvKeiyaku__card' + i"
      >
        <div class="c-topCsvKeiyaku__cards__card__item">住戸情報:</div>
        <div class="c-topCsvKeiyaku__cards__card__item">
          {{ preview[2] }}タイプ
        </div>
        <div class="c-topCsvKeiyaku__cards__card__item">
          {{ preview[3] }}m<sup>2</sup>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import LoadCsvFromPublic from "../mixin/loadCsvFromPublic";

export default {
  mixins: [LoadCsvFromPublic],
  data: function() {
    return {
      previews: [],
    };
  },
  async mounted() {
    const csvs = await this.getCsv("housing");
    const ROOM_NO_COLUMUN_INDEX = 1;

    const currentUserRoomNumberData = csvs.filter(
      _ => _[ROOM_NO_COLUMUN_INDEX] === this.currentUser.roomNo,
    );

    console.log("currentUserRoomNumberData", currentUserRoomNumberData);

    this.previews = currentUserRoomNumberData;
  },
};
</script>
